import React, {ReactElement} from 'react';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import {IElementTextInput} from '../../../incase-domain/elements/textInput';

interface ElementTextInputProps {
    element: IElementTextInput;
    device?: DeviceType;
}

function ElementTextInput(props: ElementTextInputProps): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const {label, placeholder} = element;

    return (
        <label className={getElementClasses(device)} style={getElementStyle(device, element)}>
            <div className="c-inputElement__label">{label}</div>
            <input type="text" className="c-inputElement__input" placeholder={placeholder} name={element.htmlName} autoComplete="off" />
        </label>
    );
}

function getElementStyle(device: DeviceType, element: IElementTextInput): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {
            fontFamily: element.fontFamily?.name,
        };
    }

    return {
        fontSize: `${element.font.size || 2}em`,
        fontFamily: element.fontFamily?.name,
    };
}

function getElementClasses(device: DeviceType): string {
    if (device === DeviceType.MOBILE) {
        return 'c-inputElement c-inputElement--mobile';
    }

    return 'c-inputElement';
}

export default ElementTextInput;
